import type { SVGProps } from 'react';
const SvgSmallCurvedLine = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={86} height={4} {...props}>
    <path
      fill="none"
      stroke="#FFF"
      strokeLinecap="round"
      d="M.122 2.89q36.778-3.748 85 0"
    />
  </svg>
);
export default SvgSmallCurvedLine;
